export class Bet {
    public constructor() {
        
    }

    public Team1: string;
    public Team2: string;
    public BetId: number;
    public GameId: number;
    public IconTeam1: string;
    public IconTeam2: string;
    public GoalsTeam1: number;
    public GoalsTeam2: number;
    public RealGoalsTeam1: number;
    public RealGoalsTeam2: number;
    public Schedule: Date;
    public ScheduleString: string;
    public Points: number;
    public Status: number;
    public IsScheduleChecked: boolean;
    public IsChanged: boolean;
    public IsCorrectScore: boolean;
    public IsCorrectWinner: boolean;
}


// WEBPACK FOOTER //
// ./src/entities/bet.ts